<template>
	<div class="core-top-bar">
		<div
			ref="cogs"
			:class="{ cogs: true, run: !pause }"
			@click="stopCore"
			@mouseenter="stopRunAnimation"
			@mouseover="stopRunAnimation"
			@mouseout="startRunAnimation"
			@mouseleave="startRunAnimation"
		>
			<svg class="cog-main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="25px" height="25px">
				<path
					d="M 10.490234 2 C 10.011234 2 9.6017656 2.3385938 9.5097656 2.8085938 L 9.1757812 4.5234375 C 8.3550224 4.8338012 7.5961042 5.2674041 6.9296875 5.8144531 L 5.2851562 5.2480469 C 4.8321563 5.0920469 4.33375 5.2793594 4.09375 5.6933594 L 2.5859375 8.3066406 C 2.3469375 8.7216406 2.4339219 9.2485 2.7949219 9.5625 L 4.1132812 10.708984 C 4.0447181 11.130337 4 11.559284 4 12 C 4 12.440716 4.0447181 12.869663 4.1132812 13.291016 L 2.7949219 14.4375 C 2.4339219 14.7515 2.3469375 15.278359 2.5859375 15.693359 L 4.09375 18.306641 C 4.33275 18.721641 4.8321562 18.908906 5.2851562 18.753906 L 6.9296875 18.1875 C 7.5958842 18.734206 8.3553934 19.166339 9.1757812 19.476562 L 9.5097656 21.191406 C 9.6017656 21.661406 10.011234 22 10.490234 22 L 13.509766 22 C 13.988766 22 14.398234 21.661406 14.490234 21.191406 L 14.824219 19.476562 C 15.644978 19.166199 16.403896 18.732596 17.070312 18.185547 L 18.714844 18.751953 C 19.167844 18.907953 19.66625 18.721641 19.90625 18.306641 L 21.414062 15.691406 C 21.653063 15.276406 21.566078 14.7515 21.205078 14.4375 L 19.886719 13.291016 C 19.955282 12.869663 20 12.440716 20 12 C 20 11.559284 19.955282 11.130337 19.886719 10.708984 L 21.205078 9.5625 C 21.566078 9.2485 21.653063 8.7216406 21.414062 8.3066406 L 19.90625 5.6933594 C 19.66725 5.2783594 19.167844 5.0910937 18.714844 5.2460938 L 17.070312 5.8125 C 16.404116 5.2657937 15.644607 4.8336609 14.824219 4.5234375 L 14.490234 2.8085938 C 14.398234 2.3385937 13.988766 2 13.509766 2 L 10.490234 2 z M 12 8 C 14.209 8 16 9.791 16 12 C 16 14.209 14.209 16 12 16 C 9.791 16 8 14.209 8 12 C 8 9.791 9.791 8 12 8 z"
				/>
			</svg>
			<svg class="cog-top" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16px" height="16px">
				<path
					d="M 10.490234 2 C 10.011234 2 9.6017656 2.3385938 9.5097656 2.8085938 L 9.1757812 4.5234375 C 8.3550224 4.8338012 7.5961042 5.2674041 6.9296875 5.8144531 L 5.2851562 5.2480469 C 4.8321563 5.0920469 4.33375 5.2793594 4.09375 5.6933594 L 2.5859375 8.3066406 C 2.3469375 8.7216406 2.4339219 9.2485 2.7949219 9.5625 L 4.1132812 10.708984 C 4.0447181 11.130337 4 11.559284 4 12 C 4 12.440716 4.0447181 12.869663 4.1132812 13.291016 L 2.7949219 14.4375 C 2.4339219 14.7515 2.3469375 15.278359 2.5859375 15.693359 L 4.09375 18.306641 C 4.33275 18.721641 4.8321562 18.908906 5.2851562 18.753906 L 6.9296875 18.1875 C 7.5958842 18.734206 8.3553934 19.166339 9.1757812 19.476562 L 9.5097656 21.191406 C 9.6017656 21.661406 10.011234 22 10.490234 22 L 13.509766 22 C 13.988766 22 14.398234 21.661406 14.490234 21.191406 L 14.824219 19.476562 C 15.644978 19.166199 16.403896 18.732596 17.070312 18.185547 L 18.714844 18.751953 C 19.167844 18.907953 19.66625 18.721641 19.90625 18.306641 L 21.414062 15.691406 C 21.653063 15.276406 21.566078 14.7515 21.205078 14.4375 L 19.886719 13.291016 C 19.955282 12.869663 20 12.440716 20 12 C 20 11.559284 19.955282 11.130337 19.886719 10.708984 L 21.205078 9.5625 C 21.566078 9.2485 21.653063 8.7216406 21.414062 8.3066406 L 19.90625 5.6933594 C 19.66725 5.2783594 19.167844 5.0910937 18.714844 5.2460938 L 17.070312 5.8125 C 16.404116 5.2657937 15.644607 4.8336609 14.824219 4.5234375 L 14.490234 2.8085938 C 14.398234 2.3385937 13.988766 2 13.509766 2 L 10.490234 2 z M 12 8 C 14.209 8 16 9.791 16 12 C 16 14.209 14.209 16 12 16 C 9.791 16 8 14.209 8 12 C 8 9.791 9.791 8 12 8 z"
				/>
			</svg>
			<svg class="cog-bottom" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16px" height="16px">
				<path
					d="M 10.490234 2 C 10.011234 2 9.6017656 2.3385938 9.5097656 2.8085938 L 9.1757812 4.5234375 C 8.3550224 4.8338012 7.5961042 5.2674041 6.9296875 5.8144531 L 5.2851562 5.2480469 C 4.8321563 5.0920469 4.33375 5.2793594 4.09375 5.6933594 L 2.5859375 8.3066406 C 2.3469375 8.7216406 2.4339219 9.2485 2.7949219 9.5625 L 4.1132812 10.708984 C 4.0447181 11.130337 4 11.559284 4 12 C 4 12.440716 4.0447181 12.869663 4.1132812 13.291016 L 2.7949219 14.4375 C 2.4339219 14.7515 2.3469375 15.278359 2.5859375 15.693359 L 4.09375 18.306641 C 4.33275 18.721641 4.8321562 18.908906 5.2851562 18.753906 L 6.9296875 18.1875 C 7.5958842 18.734206 8.3553934 19.166339 9.1757812 19.476562 L 9.5097656 21.191406 C 9.6017656 21.661406 10.011234 22 10.490234 22 L 13.509766 22 C 13.988766 22 14.398234 21.661406 14.490234 21.191406 L 14.824219 19.476562 C 15.644978 19.166199 16.403896 18.732596 17.070312 18.185547 L 18.714844 18.751953 C 19.167844 18.907953 19.66625 18.721641 19.90625 18.306641 L 21.414062 15.691406 C 21.653063 15.276406 21.566078 14.7515 21.205078 14.4375 L 19.886719 13.291016 C 19.955282 12.869663 20 12.440716 20 12 C 20 11.559284 19.955282 11.130337 19.886719 10.708984 L 21.205078 9.5625 C 21.566078 9.2485 21.653063 8.7216406 21.414062 8.3066406 L 19.90625 5.6933594 C 19.66725 5.2783594 19.167844 5.0910937 18.714844 5.2460938 L 17.070312 5.8125 C 16.404116 5.2657937 15.644607 4.8336609 14.824219 4.5234375 L 14.490234 2.8085938 C 14.398234 2.3385937 13.988766 2 13.509766 2 L 10.490234 2 z M 12 8 C 14.209 8 16 9.791 16 12 C 16 14.209 14.209 16 12 16 C 9.791 16 8 14.209 8 12 C 8 9.791 9.791 8 12 8 z"
				/>
			</svg>
			<svg
				ref="pauseIconCog"
				class="cog-pause"
				v-show="false"
				width="25px"
				height="25px"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M5.163 3.819C5 4.139 5 4.559 5 5.4v13.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.655c.32.164.74.164 1.581.164h.2c.84 0 1.26 0 1.581-.163a1.5 1.5 0 0 0 .656-.656c.163-.32.163-.74.163-1.581V5.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C8.861 3 8.441 3 7.6 3h-.2c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656zm9 0C14 4.139 14 4.559 14 5.4v13.2c0 .84 0 1.26.164 1.581a1.5 1.5 0 0 0 .655.655c.32.164.74.164 1.581.164h.2c.84 0 1.26 0 1.581-.163a1.5 1.5 0 0 0 .655-.656c.164-.32.164-.74.164-1.581V5.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C17.861 3 17.441 3 16.6 3h-.2c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.655.656z"
				/>
			</svg>
		</div>
		<div
			class="pause"
			v-show="pause"
			@click="openStartCoreConfirmationPopup"
			@mouseenter="showPlay"
			@mouseover="showPlay"
			@mouseout="hidePlay"
			@mouseleave="hidePlay"
		>
			<svg ref="pauseIcon" v-show="pause && loaded" width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M5.163 3.819C5 4.139 5 4.559 5 5.4v13.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.655c.32.164.74.164 1.581.164h.2c.84 0 1.26 0 1.581-.163a1.5 1.5 0 0 0 .656-.656c.163-.32.163-.74.163-1.581V5.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C8.861 3 8.441 3 7.6 3h-.2c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656zm9 0C14 4.139 14 4.559 14 5.4v13.2c0 .84 0 1.26.164 1.581a1.5 1.5 0 0 0 .655.655c.32.164.74.164 1.581.164h.2c.84 0 1.26 0 1.581-.163a1.5 1.5 0 0 0 .655-.656c.164-.32.164-.74.164-1.581V5.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C17.861 3 17.441 3 16.6 3h-.2c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.655.656z"
				/>
			</svg>
			<svg
				v-show="false"
				ref="playIcon"
				class="play"
				width="20px"
				height="20px"
				viewBox="-0.5 0 7 7"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
			>
				<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="Dribbble-Light-Preview" transform="translate(-347.000000, -3766.000000)" fill="#000000">
						<g id="icons" transform="translate(56.000000, 160.000000)">
							<path
								d="M296.494737,3608.57322 L292.500752,3606.14219 C291.83208,3605.73542 291,3606.25002 291,3607.06891 L291,3611.93095 C291,3612.7509 291.83208,3613.26444 292.500752,3612.85767 L296.494737,3610.42771 C297.168421,3610.01774 297.168421,3608.98319 296.494737,3608.57322"
								id="play-[#1003]"
							></path>
						</g>
					</g>
				</g>
			</svg>
			<v-progress-circular v-show="pause && !loaded" :size="25" color="primary" indeterminate></v-progress-circular>
		</div>
		<v-dialog v-model="coreStartDialog" max-width="400">
			<v-card>
				<v-card-title class="headline">{{ $t('confirm_core_start') }}</v-card-title>
				<v-card-text>
					{{ $t('confirm_core_start_warning') }}
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="coreStartDialog = false">{{ $t('cancel') }}</v-btn>
					<v-btn text color="red" @click="startCore">{{ $t('start_algorithm') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	data() {
		return {
			pause: false,
			loaded: false,
			coreStartDialog: false,
		};
	},
	computed: {
		...mapState({
			status: (state) => state.core.status,
			user: (state) => state.auth.user,
		}),
	},
	methods: {
		...mapActions({
			loadStatus: 'core/loadStatus',
			setRunning: 'core/setRunning',
			update: 'core/update',
			evaluate: 'core/evaluate',
			clearCache: 'core/clearCache',
		}),
		stopCore() {
			if (!this.user.permissions['core.edit']) {
				return;
			}
			this.$refs.pauseIconCog.style.display = 'none';
			this.loaded = false;

			this.setRunning(false);
			this.pause = true;
		},
		openStartCoreConfirmationPopup() {
			if (!this.user.permissions['core.edit']) {
				return;
			}
			this.coreStartDialog = true;
		},
		startCore() {
			if (!this.user.permissions['core.edit']) {
				return;
			}
			this.$refs.playIcon.style.display = 'none';
			this.loaded = false;
			this.coreStartDialog = false;

			this.setRunning(true);
			this.pause = false;
		},
		showPlay() {
			if (!this.user.permissions['core.edit']) {
				return;
			}
			if (this.pause && this.loaded) {
				this.$refs.pauseIcon.style.display = 'none';
				this.$refs.playIcon.style.display = 'block';
			}
		},
		hidePlay() {
			if (!this.user.permissions['core.edit']) {
				return;
			}
			if (this.pause && this.loaded) {
				this.$refs.pauseIcon.style.display = 'block';
				this.$refs.playIcon.style.display = 'none';
			}
		},
		showPause() {
			if (!this.user.permissions['core.edit']) {
				return;
			}
			if (this.pause && this.loaded) {
				this.$refs.pauseIcon.style.display = 'block';
			}
		},
		hidePause() {
			if (!this.user.permissions['core.edit']) {
				return;
			}
			if (this.pause && this.loaded) {
				this.$refs.pauseIcon.style.display = 'none';
			}
		},
		stopRunAnimation() {
			if (!this.user.permissions['core.edit']) {
				return;
			}
			if (!this.pause && this.loaded) {
				this.$refs.cogs.classList.remove('run');
				this.$refs.pauseIconCog.style.display = 'block';
			}
		},
		startRunAnimation() {
			if (!this.user.permissions['core.edit']) {
				return;
			}
			if (!this.pause && this.loaded) {
				this.$refs.cogs.classList.add('run');
				this.$refs.pauseIconCog.style.display = 'none';
			}
		},
	},
	async created() {
		await this.loadStatus();
		this.loaded = true;
		this.pause = !this.status?.process?.running;
	},
	watch: {
		'status.process'(val) {
			this.loaded = true;
			this.pause = !val?.running;
		},
	},
};
</script>

<style scoped>
.core-top-bar {
	cursor: pointer;
	margin-right: 80px;
}

.core-top-bar path {
	fill: rgb(var(--v-theme-primary));
}

.cogs {
	background: rgb(var(--v-theme-grey-300));
	border-radius: 50%;

	min-width: 39px;
	min-height: 39px;
}

.cogs.run {
	background: transparent;
	border-radius: 50%;

	min-width: 39px;
	min-height: 39px;
}

.cog-main {
	position: absolute;
	margin-top: 6px;
}

.cog-top {
	position: absolute;
	margin-left: 20px;
	margin-top: 3px;
}

.cog-bottom {
	position: absolute;
	margin-left: 20px;
	margin-top: 18px;
}

.cog-pause {
	position: absolute;
	margin-left: 7px;
	margin-top: 5px;
}

.cog-pause path {
	fill: #000;
}

.pause {
	position: absolute;
	margin-top: -39px;
	background: rgb(var(--v-theme-grey-300));
	padding: 7px 7px 0px 7px;
	border-radius: 50%;
	opacity: 0.8;

	min-width: 39px;
	min-height: 39px;
}

.pause path {
	fill: black;
}

.play {
	position: absolute;
	margin-left: 3px;
	margin-top: 3px;
}

.run svg.cog-main {
	-webkit-animation: rotating-clock 2.5s linear infinite;
	-moz-animation: rotating-clock 2.5s linear infinite;
	-ms-animation: rotating-clock 2.5s linear infinite;
	-o-animation: rotating-clock 2.5s linear infinite;
	animation: rotating-clock 2.5s linear infinite;
}

.run svg.cog-top,
.run svg.cog-bottom {
	-webkit-animation: rotating-counterclock 2.5s linear infinite;
	-moz-animation: rotating-counterclock 2.5s linear infinite;
	-ms-animation: rotating-counterclock 2.5s linear infinite;
	-o-animation: rotating-counterclock 2.5s linear infinite;
	animation: rotating-counterclock 2.5s linear infinite;
}

@-webkit-keyframes rotating-clock /* Safari and Chrome */ {
	from {
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@keyframes rotating-clock {
	from {
		-ms-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-ms-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

@-webkit-keyframes rotating-counterclock /* Safari and Chrome */ {
	from {
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
	to {
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
}
@keyframes rotating-counterclock {
	from {
		-ms-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
	to {
		-ms-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
}
</style>
